export interface LocationScene {
  region: string;
  place: string;
}

export interface DestinationScenesConfig {
  desktop: LocationScene[];
  mobile: LocationScene[];
}

export const DESTINATION_VIDEO_SCENES: Record<string, DestinationScenesConfig> = {
  'sri-lanka': {
    desktop: [
      { region: 'SRI LANKA · SOUTH COAST', place: 'Galle Fort Lighthouse' },
      { region: 'SRI LANKA · SOUTH COAST', place: 'Coconut Tree Hill, Mirissa' },
      { region: 'SRI LANKA · CULTURAL TRIANGLE', place: 'Sigiriya Rock Fortress' },
      { region: 'SRI LANKA · HILL COUNTRY', place: 'Nine Arch Bridge, Ella' }
    ],
    mobile: [
      { region: 'SRI LANKA · CULTURAL TRIANGLE', place: 'Sigiriya Rock Fortress' },
      { region: 'SRI LANKA · HILL COUNTRY', place: 'Nine Arch Bridge, Ella' },
      { region: 'SRI LANKA · SOUTH COAST', place: 'Galle Fort Lighthouse' },
      { region: 'SRI LANKA · SOUTH COAST', place: 'Coconut Tree Hill, Mirissa' }
    ]
  },
  'andaman': {
    desktop: [
      { region: 'ANDAMAN · HAVELOCK ISLAND', place: 'Radhanagar Beach' },
      { region: 'ANDAMAN · PORT BLAIR', place: 'Cellular Jail' },
      { region: 'ANDAMAN · HAVELOCK ISLAND', place: 'Elephant Beach Coral Reef' },
      { region: 'ANDAMAN · NEIL ISLAND', place: 'Natural Rock Bridge' }
    ],
    mobile: [
      { region: 'ANDAMAN · HAVELOCK ISLAND', place: 'Radhanagar Beach' },
      { region: 'ANDAMAN · NEIL ISLAND', place: 'Natural Rock Bridge' },
      { region: 'ANDAMAN · PORT BLAIR', place: 'Cellular Jail Tower' },
      { region: 'ANDAMAN · PORT BLAIR', place: 'Cellular Jail Courtyard' }
    ]
  },
  'chardham': {
    desktop: [
      { region: 'CHAR DHAM · UTTARAKHAND', place: 'Yamunotri Temple' },
      { region: 'CHAR DHAM · UTTARAKHAND', place: 'Gangotri Temple' },
      { region: 'CHAR DHAM · UTTARAKHAND', place: 'Kedarnath Temple' },
      { region: 'CHAR DHAM · UTTARAKHAND', place: 'Badrinath Temple' }
    ],
    mobile: [
      { region: 'CHAR DHAM · UTTARAKHAND', place: 'Kedarnath Temple' },
      { region: 'CHAR DHAM · UTTARAKHAND', place: 'Badrinath Temple' },
      { region: 'CHAR DHAM · UTTARAKHAND', place: 'Himalayan Pilgrim Trek' },
      { region: 'CHAR DHAM · UTTARAKHAND', place: 'Gangotri Temple' }
    ]
  },
  'dubai': {
    desktop: [
      { region: 'DUBAI · SHEIKH ZAYED ROAD', place: 'Museum of the Future' },
      { region: 'DUBAI · ARABIAN DESERT', place: 'Desert Dunes Safari' },
      { region: 'DUBAI · DOWNTOWN', place: 'Burj Khalifa & Dubai Fountain' },
      { region: 'DUBAI · JUMEIRAH', place: 'Palm Jumeirah' }
    ],
    mobile: [
      { region: 'DUBAI · DOWNTOWN', place: 'Burj Khalifa' },
      { region: 'DUBAI · JUMEIRAH', place: 'Palm Jumeirah' },
      { region: 'DUBAI · SHEIKH ZAYED ROAD', place: 'Museum of the Future' },
      { region: 'DUBAI · ARABIAN DESERT', place: 'Desert Dunes Safari' }
    ]
  },
  'europe-1': {
    desktop: [
      { region: 'NETHERLANDS · AMSTERDAM', place: 'Canals of Amsterdam' },
      { region: 'SWITZERLAND · ZERMATT', place: 'The Matterhorn' },
      { region: 'FRANCE · PARIS', place: 'The Eiffel Tower' },
      { region: 'CZECH REPUBLIC · PRAGUE', place: 'Charles Bridge' }
    ],
    mobile: [
      { region: 'NETHERLANDS · AMSTERDAM', place: 'Canals of Amsterdam' },
      { region: 'SWITZERLAND · ZERMATT', place: 'The Matterhorn' },
      { region: 'FRANCE · PARIS', place: 'The Eiffel Tower' },
      { region: 'CZECH REPUBLIC · PRAGUE', place: 'Charles Bridge' }
    ]
  },
  'europe-2': {
    desktop: [
      { region: 'SWITZERLAND · ZURICH', place: 'Grossmünster & Lake Zurich' },
      { region: 'ITALY · VENICE', place: 'Grand Canal & Rialto Bridge' },
      { region: 'ITALY · FLORENCE', place: 'Florence Cathedral (Duomo)' },
      { region: 'ITALY · ROME', place: 'The Colosseum' }
    ],
    mobile: [
      { region: 'SWITZERLAND · ZURICH', place: 'Grossmünster & Lake Zurich' },
      { region: 'ITALY · VENICE', place: 'Grand Canal & Rialto Bridge' },
      { region: 'ITALY · FLORENCE', place: 'Florence Cathedral (Duomo)' },
      { region: 'ITALY · ROME', place: 'The Colosseum' }
    ]
  },
  'global': {
    desktop: [
      { region: 'EGYPT · GIZA', place: 'Great Pyramids of Giza' },
      { region: 'CHINA · BEIJING', place: 'Great Wall of China' },
      { region: 'PERU · ANDES', place: 'Machu Picchu' },
      { region: 'JORDAN · PETRA', place: 'The Treasury (Al-Khazneh)' }
    ],
    mobile: [
      { region: 'PERU · ANDES', place: 'Machu Picchu' },
      { region: 'JORDAN · PETRA', place: 'The Treasury (Al-Khazneh)' },
      { region: 'EGYPT · GIZA', place: 'Great Pyramids of Giza' },
      { region: 'CHINA · BEIJING', place: 'Great Wall of China' }
    ]
  },
  'goa': {
    desktop: [
      { region: 'GOA · MOLLEM', place: 'Dudhsagar Waterfalls' },
      { region: 'GOA · SINQUERIM', place: 'Fort Aguada Lighthouse' },
      { region: 'GOA · PANAJI', place: 'Fontainhas Latin Quarter' },
      { region: 'GOA · CANACONA', place: 'Palolem Beach' }
    ],
    mobile: [
      { region: 'GOA · MOLLEM', place: 'Dudhsagar Waterfalls' },
      { region: 'GOA · SINQUERIM', place: 'Fort Aguada Lighthouse' },
      { region: 'GOA · PANAJI', place: 'Fontainhas Latin Quarter' },
      { region: 'GOA · CANACONA', place: 'Palolem Beach' }
    ]
  },
  'hong-kong': {
    desktop: [
      { region: 'HONG KONG · CAUSEWAY BAY', place: 'Causeway Bay' },
      { region: 'HONG KONG · LANTAU ISLAND', place: 'Tian Tan Buddha' },
      { region: 'HONG KONG · VICTORIA PEAK', place: 'Victoria Harbour Skyline' },
      { region: 'HONG KONG · LANTAU', place: 'Hong Kong Disneyland' }
    ],
    mobile: [
      { region: 'HONG KONG · CENTRAL', place: 'Luxury Shopping District' },
      { region: 'HONG KONG · LANTAU ISLAND', place: 'Tian Tan Buddha' },
      { region: 'HONG KONG · VICTORIA PEAK', place: 'Peak Tram Skyscraper Climb' },
      { region: 'HONG KONG · LANTAU', place: 'Hong Kong Disneyland' }
    ]
  },
  'india': {
    desktop: [
      { region: 'INDIA · AGRA', place: 'The Taj Mahal' },
      { region: 'INDIA · VARANASI', place: 'Ganga Aarti, Dashashwamedh Ghat' },
      { region: 'INDIA · KERALA', place: 'Alleppey Backwaters' },
      { region: 'INDIA · RAJASTHAN', place: 'Hawa Mahal, Jaipur' }
    ],
    mobile: [
      { region: 'INDIA · KERALA', place: 'Alleppey Backwaters' },
      { region: 'INDIA · RAJASTHAN', place: 'Hawa Mahal, Jaipur' },
      { region: 'INDIA · AGRA', place: 'The Taj Mahal' },
      { region: 'INDIA · VARANASI', place: 'Ganga Aarti, Dashashwamedh Ghat' }
    ]
  },
  'indonesia': {
    desktop: [
      { region: 'BALI · ULUWATU', place: 'Uluwatu Sunset Cliff' },
      { region: 'BALI · UBUD', place: 'Tegallalang Rice Terrace Swing' },
      { region: 'BALI · NUSA PENIDA', place: 'Kelingking Beach' },
      { region: 'BALI · TABANAN', place: 'Tanah Lot Temple' }
    ],
    mobile: [
      { region: 'BALI · NUSA PENIDA', place: 'Kelingking Beach' },
      { region: 'BALI · TABANAN', place: 'Tanah Lot Temple' },
      { region: 'BALI · ULUWATU', place: 'Uluwatu Sunset Cliff' },
      { region: 'BALI · UBUD', place: 'Tegallalang Rice Terraces' }
    ]
  },
  'japan': {
    desktop: [
      { region: 'JAPAN · HONSHU', place: 'Mount Fuji' },
      { region: 'JAPAN · KYOTO', place: 'Arashiyama Bamboo Grove' },
      { region: 'JAPAN · TOKYO', place: 'Shibuya Crossing' },
      { region: 'JAPAN · KYOTO', place: 'Fushimi Inari Shrine' }
    ],
    mobile: [
      { region: 'JAPAN · HONSHU', place: 'Mount Fuji' },
      { region: 'JAPAN · KYOTO', place: 'Arashiyama Bamboo Grove' },
      { region: 'JAPAN · TOKYO', place: 'Shibuya Crossing' },
      { region: 'JAPAN · KYOTO', place: 'Fushimi Inari Shrine' }
    ]
  },
  'malaysia': {
    desktop: [
      { region: 'MALAYSIA · KUALA LUMPUR', place: 'Petronas Twin Towers' },
      { region: 'MALAYSIA · SELANGOR', place: 'Batu Caves' },
      { region: 'MALAYSIA · LANGKAWI', place: 'Langkawi Sky Bridge' },
      { region: 'MALAYSIA · PAHANG', place: 'Cameron Highlands' }
    ],
    mobile: [
      { region: 'MALAYSIA · LANGKAWI', place: 'Langkawi Sky Bridge' },
      { region: 'MALAYSIA · PAHANG', place: 'Cameron Highlands' },
      { region: 'MALAYSIA · KUALA LUMPUR', place: 'Petronas Twin Towers' },
      { region: 'MALAYSIA · SELANGOR', place: 'Batu Caves' }
    ]
  },
  'maldives': {
    desktop: [
      { region: 'MALDIVES · TROPICAL ATOLL', place: 'Overwater Lagoon' },
      { region: 'MALDIVES · NORTH MALÉ ATOLL', place: 'Catamaran Sailing' },
      { region: 'MALDIVES · RESORT ISLAND', place: 'Tropical Island Palms' },
      { region: 'MALDIVES · SOUTH MALÉ ATOLL', place: 'Turquoise Waters' }
    ],
    mobile: [
      { region: 'MALDIVES · NORTH MALÉ ATOLL', place: 'Catamaran Sailing' },
      { region: 'MALDIVES · TROPICAL ATOLL', place: 'Crystal Lagoon Reef' },
      { region: 'MALDIVES · RESORT ISLAND', place: 'Tropical Island Palms' },
      { region: 'MALDIVES · SOUTH MALÉ ATOLL', place: 'Turquoise Waters' }
    ]
  },
  'mauritius': {
    desktop: [
      { region: 'MAURITIUS · BLACK RIVER', place: 'Le Morne Brabant' },
      { region: 'MAURITIUS · SOUTHWEST COAST', place: 'Catamaran Lagoon Cruise' },
      { region: 'MAURITIUS · PAMPLEMOUSSES', place: 'SSR Botanical Garden' },
      { region: 'MAURITIUS · EAST COAST', place: 'Belle Mare Beach' }
    ],
    mobile: [
      { region: 'MAURITIUS · SOUTHWEST COAST', place: 'Catamaran Lagoon Cruise' },
      { region: 'MAURITIUS · BLACK RIVER', place: 'Le Morne Crystal Lagoon' },
      { region: 'MAURITIUS · PAMPLEMOUSSES', place: 'SSR Botanical Garden' },
      { region: 'MAURITIUS · EAST COAST', place: 'Belle Mare Beach' }
    ]
  },
  'mumbai': {
    desktop: [
      { region: 'CORDELIA CRUISES · MUMBAI', place: 'Gateway of India Cruise Departure' },
      { region: 'CORDELIA CRUISES · ARABIAN SEA', place: 'Sunset Ocean Sailing' },
      { region: 'CORDELIA CRUISES · POOL DECK', place: 'Open-Air Pool & Sundeck' },
      { region: 'CORDELIA CRUISES · ENTERTAINMENT', place: 'The Marquee Theatre Show' }
    ],
    mobile: [
      { region: 'CORDELIA CRUISES · MUMBAI', place: 'Gateway of India Cruise Departure' },
      { region: 'CORDELIA CRUISES · ARABIAN SEA', place: 'Sunset Ocean Sailing' },
      { region: 'CORDELIA CRUISES · POOL DECK', place: 'Open-Air Pool & Sundeck' },
      { region: 'CORDELIA CRUISES · ENTERTAINMENT', place: 'The Marquee Theatre Show' }
    ]
  },
  'north-india': {
    desktop: [
      { region: 'LADAKH · LEH', place: 'Leh Palace' },
      { region: 'LADAKH · HIMALAYAS', place: 'Pangong Tso Lake' },
      { region: 'KASHMIR · PAHALGAM', place: 'Betaab Valley & Pine Forests' },
      { region: 'KASHMIR · SRINAGAR', place: 'Dal Lake Shikara Sunset' }
    ],
    mobile: [
      { region: 'LADAKH · LEH', place: 'Old Leh Town' },
      { region: 'LADAKH · HIMALAYAS', place: 'Pangong Tso Lake' },
      { region: 'KASHMIR · PAHALGAM', place: 'Betaab Valley & Pine Forests' },
      { region: 'KASHMIR · SRINAGAR', place: 'Dal Lake Shikara Sunset' }
    ]
  },
  'singapore': {
    desktop: [
      { region: 'SINGAPORE · MARINA BAY', place: 'Merlion Park' },
      { region: 'SINGAPORE · SENTOSA', place: 'Palawan Beach' },
      { region: 'SINGAPORE · MARINA BAY', place: 'Marina Bay Sands & Supertrees' },
      { region: 'SINGAPORE · CHANGI', place: 'Jewel Rain Vortex' }
    ],
    mobile: [
      { region: 'SINGAPORE · MARINA BAY', place: 'Merlion Park' },
      { region: 'SINGAPORE · SENTOSA', place: 'Palawan Beach' },
      { region: 'SINGAPORE · MARINA BAY', place: 'Marina Bay Sands & Supertrees' },
      { region: 'SINGAPORE · CHANGI', place: 'Jewel Rain Vortex' }
    ]
  },
  'south-india': {
    desktop: [
      { region: 'KERALA · ALLEPPEY', place: 'Vembanad Backwaters' },
      { region: 'KERALA · WAYANAD', place: 'Cardamom & Spice Plantations' },
      { region: 'KERALA · MUNNAR', place: 'Munnar Tea Estates' },
      { region: 'KERALA · MUNNAR', place: 'Kundala Lake & Valley' }
    ],
    mobile: [
      { region: 'KERALA · ALLEPPEY', place: 'Vembanad Backwaters' },
      { region: 'KERALA · WAYANAD', place: 'Cardamom & Spice Plantations' },
      { region: 'KERALA · MUNNAR', place: 'Munnar Tea Estates' },
      { region: 'KERALA · MUNNAR', place: 'Kundala Lake & Valley' }
    ]
  },
  'thailand': {
    desktop: [
      { region: 'THAILAND · BANGKOK', place: 'Grand Palace & Wat Phra Kaew' },
      { region: 'THAILAND · PHI PHI ISLANDS', place: 'Maya Bay' },
      { region: 'THAILAND · BANGKOK', place: 'Wat Arun (Temple of Dawn)' },
      { region: 'THAILAND · CHIANG MAI', place: 'Yi Peng Lantern Festival' }
    ],
    mobile: [
      { region: 'THAILAND · BANGKOK', place: 'Grand Palace & Wat Phra Kaew' },
      { region: 'THAILAND · PHI PHI ISLANDS', place: 'Maya Bay' },
      { region: 'THAILAND · BANGKOK', place: 'Wat Arun (Temple of Dawn)' },
      { region: 'THAILAND · CHIANG MAI', place: 'Yi Peng Lantern Festival' }
    ]
  },
  'vietnam': {
    desktop: [
      { region: 'VIETNAM · QUẢNG NINH', place: 'Ha Long Bay' },
      { region: 'VIETNAM · DA NANG', place: 'Golden Bridge, Ba Na Hills' },
      { region: 'VIETNAM · QUẢNG NAM', place: 'Hoi An Ancient Town' },
      { region: 'VIETNAM · YÊN BÁI', place: 'Mu Cang Chai Rice Terraces' }
    ],
    mobile: [
      { region: 'VIETNAM · QUẢNG NINH', place: 'Ha Long Bay' },
      { region: 'VIETNAM · DA NANG', place: 'Golden Bridge, Ba Na Hills' },
      { region: 'VIETNAM · QUẢNG NAM', place: 'Hoi An Ancient Town' },
      { region: 'VIETNAM · YÊN BÁI', place: 'Mu Cang Chai Rice Terraces' }
    ]
  }
};

/**
 * Returns the destination scene for a specific time and variant.
 */
export function getDestinationScene(
  destId: string | null | undefined,
  variant: 'desktop' | 'mobile',
  currentTimeSeconds: number,
  totalDurationSeconds: number = 20
): { scene: LocationScene | null; sceneIndex: number; isVisible: boolean } {
  if (!destId) {
    destId = 'global';
  }

  const config = DESTINATION_VIDEO_SCENES[destId] || DESTINATION_VIDEO_SCENES['global'];
  const scenes = (variant === 'mobile' ? config.mobile : config.desktop) || config.desktop;

  if (!scenes || scenes.length === 0) {
    return { scene: null, sceneIndex: -1, isVisible: false };
  }

  const duration = totalDurationSeconds > 0 && isFinite(totalDurationSeconds) ? totalDurationSeconds : 20;
  const sceneDuration = duration / scenes.length; // usually ~5.0 seconds
  const rawTime = (currentTimeSeconds % duration + duration) % duration;
  const sceneIndex = Math.min(scenes.length - 1, Math.floor(rawTime / sceneDuration));
  const timeInScene = rawTime - sceneIndex * sceneDuration;

  // Fade window:
  // 0.0s - 0.25s: cut has just happened, prepare / fade in starts
  // 0.25s - sceneDuration - 0.7s: fully visible
  // sceneDuration - 0.7s - sceneDuration - 0.15s: fading out before scene cut
  // sceneDuration - 0.15s - sceneDuration: hidden for clean video cut
  const fadeInPoint = 0.25;
  const fadeOutPoint = Math.max(fadeInPoint + 1.0, sceneDuration - 0.7);

  const isVisible = timeInScene >= fadeInPoint && timeInScene <= fadeOutPoint;

  return {
    scene: scenes[sceneIndex] || null,
    sceneIndex,
    isVisible
  };
}
